module.exports = __webpack_public_path__ + "img/2.8d734c87.jpg";